import React from 'react';
import PropTypes from 'prop-types';

import styles from './ActionEdited.module.css';

export  class ActionEdited extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
    }

    render() {
        return (
            <div className={styles.base} onClick={this.props.onClick} />
        )
    }
}
